import { createTheme } from "@mui/material";
import { THEME_COLOR_PALETTE } from "./palette";

const MOBILE_BREAKPOINT = 768;

const POWERREADY_THEME = createTheme({
  components: {
    MuiLink: {
      defaultProps: {
        classes: {
          root: "my-class",
        },
      },
    },
  },
  breakpoints: {
    values: {
      xs: 0,
      sm: MOBILE_BREAKPOINT,
      md: 1000,
      lg: 1200,
      xl: 1536,
    },
  },
  typography: {
    fontFamily: ["OpenSans", "Lexend", "sans-serif"].join(","),

    h1: {
      fontSize: "33px",
      fontWeight: 900,
      lineHeight: "60px",
      [`@media (max-width:${MOBILE_BREAKPOINT}px)`]: {
        fontSize: "33px",
        fontWeight: 900,
        lineHeight: "43px",
      },
    },
    h2: {
      fontSize: "23px",
      fontWeight: 900,
      lineHeight: "43px",
      [`@media (max-width:${MOBILE_BREAKPOINT}px)`]: {
        fontSize: "23px",
        fontWeight: 900,
        lineHeight: "30px",
      },
    },
    h3: {
      fontSize: "20px",
      fontWeight: 900,
      lineHeight: "30px",
      [`@media (max-width:${MOBILE_BREAKPOINT}px)`]: {
        fontSize: "23px",
        fontWeight: 900,
        lineHeight: "24px",
      },
    },
    h4: {
      fontSize: "16px",
      fontWeight: 900,
      lineHeight: "18px",
      [`@media (max-width:${MOBILE_BREAKPOINT}px)`]: {
        fontSize: "16px",
        fontWeight: 900,
        lineHeight: "18px",
      },
    },
    body1: {
      fontSize: "18px",
      fontWeight: 400,
      lineHeight: "27px",
      [`@media (max-width:${MOBILE_BREAKPOINT}px)`]: {
        fontSize: "18px",
        fontWeight: 400,
        lineHeight: "27px",
      },
    },
    body2: {
      fontSize: "16px",
      fontWeight: 400,
      lineHeight: "24px",
      [`@media (max-width:${MOBILE_BREAKPOINT}px)`]: {
        fontSize: "16px",
        fontWeight: 400,
        lineHeight: "24px",
      },
    },
    unset: {
      fontSize: "initial",
      lineHeight: "initial",
    },
  },
  palette: THEME_COLOR_PALETTE,
});

export default POWERREADY_THEME;
